// How the vocabulary reads on the page. The database stores the machine words;
// nothing in the interface should show a reader an underscore.
export const STATUS_LABEL = {
  canonical: "Canonical", traditional: "Traditional", modern: "Modern",
  contested: "Contested", disputed: "Disputed", unsourced: "Unsourced"
};

export const SACRED_LABEL = {
  attested: "Ancient source attested",
  none_located: "No ancient source found",
  not_investigated: "Ancient sources not checked"
};

// The distinction the whole section turns on. "None located" is a FINDING and
// is written as one; a blank means nobody has looked, which is a different
// thing and must never read as "no".
export const SACRED_SHORT = {
  attested: "Ancient source",
  none_located: "None found",
  not_investigated: "Not checked"
};

export const EVIDENCE_LABEL = {
  explicit: "The source states it",
  derived: "Derived from several passages"
};

export const SOURCE_CLASS_LABEL = {
  sacred_primary: "Sacred / scriptural primary",
  ancient_primary: "Ancient primary",
  esoteric_primary: "Esoteric primary",
  later_traditional: "Later tradition",
  scholarly: "Modern scholarship"
};

export const TRANSMISSION_LABEL = {
  originates: "originates it",
  repeats: "repeats it",
  adapts: "adapts it",
  systematises: "systematises it",
  rejects: "rejects it"
};

export function yearLabel(year) {
  if (year === null || year === undefined) return null;
  return year < 0 ? `${Math.abs(year)} BCE` : `${year} CE`;
}
